import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { isAmppa } from "../../../utils/isAmppa";

import "./HeaderNav.css";
import AmpNewHighlight from "../AmpNewHighlight/AmpNewHighlight";

export interface HeaderNavProps {
    isAuthed: boolean
    pierSplash?: boolean
}

interface HeaderLink {
    title: string | JSX.Element;
    link: string;
}

export default function HeaderNav(props: HeaderNavProps): JSX.Element {
    let links: Array<HeaderLink | null>;

    const { t } = useTranslation('header');

    const location = useLocation();
    const isAgent = window.localStorage.getItem("isAgent") === "Y";

    if (!props.isAuthed) {
        links = [
            (!isAmppa ?
                {
                    title: t('header-2.register'),
                    link: '/auth/home'
                } : null),
            (!isAmppa ?
            {
                title: t('header-2.sign-in'),
                link: '/auth/home/reg-user'
            } : null),
            {
                title: t('header-2.contact'),
                link: '/auth/contact-us'
            }
        ]
    } else if (props.isAuthed && props.pierSplash) {
        links = [
            {
                title: t('header-2.sign-out'),
                link: '/amp/signout'
            },
            {
                title: t('header-2.contact'),
                link: '/amp/contact-us'
            }
        ];
    } else {
        links = [
            {
                title: t('header-2.home'),
                link: '/amp'
            },
            !isAmppa ?
                {
                    title:(<>
                        {!isAgent && <AmpNewHighlight
                            size="slim"
                            prefaceImage={""}
                        />}
                        <div>{t('header-2.mma')}</div>
                    </>),
                    link: '/amp/profile'
                } : null,
            {
                title: t('header-2.sign-out'),
                link: '/amp/signout'
            },
            {
                title: t('header-2.contact'),
                link: '/amp/contact-us'
            }
        ];
    }

    const linkLength = links.length;
    return (
        <div className="header-second-row-item">
            {links.map((value, index: number) => {
                if (value !== null) {
                    const className = value.link === location.pathname ? "active" : ""
                    return (
                        <>
                            <div className={className}>
                                <Link className="amp-anchor nav-anchor" to={value.link}>
                                    {value.title}
                                </Link>
                            </div>
                            {(index + 1) === linkLength ? "" : <div className="nav-divider">|</div>}
                        </>
                    )
                }
                return null;
            })}
        </div>
    );
}